<div class="cards">
  <div class="cards__loading" *ngIf="loading">
    <app-spinner size="huge"></app-spinner>
  </div>

  <div class="cards__content">
    <ng-content select="app-card"></ng-content>
  </div>
</div>